import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { setTrim } from '../../../../lib/common';
import RejectBanProductModal from '../../../../views/product/common/modal/RejectBanProductModal';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class RejectBanProductModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //--> 상품 거절 사유 타입
      type: 0,
      //--> 상품 거절
      reason: null,
    };
  }

  /**
   * 상품 판매 금지하기
   */
  onSubmit = () => {
    const { form, data, rejectBanProduct } = this.props;
    const { type, reason } = this.state;
    const { productId, productUpdateLogId, isBanRequest } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      rejectBanProduct({
        productId,
        productUpdateLogId,
        type,
        reason: setTrim(reason),
        isBanRequest,
      });

      /**
       * 모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'rejectBanProductModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <RejectBanProductModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.rejectBanProductModal.isOpen,
    data: state.product.rejectBanProductModal.data,
  };
};

const mapDispatchToProps = {
  rejectBanProduct: productActions.rejectBanProduct,
  toggleModal: productActions.toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(RejectBanProductModalContainer)));
